import React from "react";
import {
    FileText,
    Clock,
    AlertCircle,
    Shuffle,
    Database,
    Calendar,
    DollarSign,
    Layers,
} from "react-feather";
import Paperworkimg from "../../assets/images/landingpage/pape-work.jpg"
import pcworkimg from "../../assets/images/landingpage/comap-pc.jpg"


const traditional = [
    { 
        icon: FileText, 
        title: "Paper files", 
        desc: "Overwhelming paperwork leads to cluttered storage, misplaced records, and difficulty in retrieving patient history quickly when needed." 
    },
    { 
        icon: Clock, 
        title: "Waiting patients", 
        desc: "Manual appointment handling creates long queues, increased waiting times, and frustration for both patients and staff." 
    },
    { 
        icon: AlertCircle, 
        title: "Billing confusion", 
        desc: "Handwritten or manual billing processes often result in calculation mistakes, missing entries, and disputes with patients." 
    },
    { 
        icon: Shuffle, 
        title: "Disorganized workflow", 
        desc: "Lack of coordination between departments causes delays, duplicated work, and inefficient use of hospital resources." 
    },
];

const digital = [
    { 
        icon: Database, 
        title: "Digital patient records", 
        desc: "Secure electronic medical records (EMR) allow instant access to patient history, reduce errors, and enable seamless sharing across departments." 
    },
    { 
        icon: Calendar, 
        title: "Automated scheduling", 
        desc: "Smart scheduling systems optimize appointment slots, reduce waiting times, and send reminders to minimize no-shows." 
    },
    { 
        icon: DollarSign, 
        title: "Smart billing system", 
        desc: "Automated billing ensures accurate calculations, transparent invoices, insurance integration, and faster payment processing." 
    },
    { 
        icon: Layers, 
        title: "Integrated hospital software", 
        desc: "All departments are connected through a unified platform, providing real-time data, better coordination, and improved decision-making." 
    },
];

const CompareSection = () => {
    return (
        <section className="py-5 bg-white">
            <div className="container">

                {/* Heading */}
                <div className="text-center mb-5" data-aos="zoom-in">
                    <h2 className="fw-bold fs-1">
                        Traditional vs <span className="lanp-secondary-text">Digital Healthcare</span>
                    </h2>
                    <p className="text-muted mb-0">
                        Transforming inefficiencies into smart, connected systems
                    </p>
                </div>

                <div className="row">

                    {/* LEFT SIDE - TRADITIONAL */}
                    <div className="col-lg-12 mb-4 mb-lg-0">
                        <div className="bg-light rounded shadow-sm p-4 h-100" data-aos="zoom-in">

                            <h4 className="fw-bold text-dark mb-2" data-aos="zoom-in">
                                Challenges in Traditional Hospital Systems
                            </h4>

                            <p className="text-muted mb-4" data-aos="zoom-in">
                                Legacy inefficiencies & manual processes
                            </p>

                            <div className="row">
                                <div className="col-md-6">
                                    <img src={Paperworkimg} alt=" " className="w-100 rounded mb-4" />

                                </div>
                                <div className="col-md-6">
                                    {traditional.map((item, index) => {
                                        const Icon = item.icon;

                                        return (
                                            <div
                                                key={index}
                                                className="d-flex align-items-start mb-3"
                                                data-aos="fade-right"
                                                data-aos-delay={index * 100}
                                            >
                                                <div className="me-3 lanp-primary-text fw-bold">
                                                    <Icon size={20} />
                                                </div>
                                                <div>
                                                    <h6 className="fw-semibold mb-1 text-dark">{item.title}</h6>
                                                    <small className="text-muted">{item.desc}</small>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT SIDE - DIGITAL */}
                    <div className="col-lg-12">
                        <div className="bg-light text-dark rounded shadow-sm p-4 h-100" data-aos="zoom-in">

                            <h4 className="fw-bold mb-2 text-end" data-aos="zoom-in">
                                The AZSM Digital Solution
                            </h4>

                            <p className="mb-4 text-end" data-aos="zoom-in">
                                Efficiency, accuracy & seamless integration
                            </p>

                            <div className="row">
                                <div className="col-md-6">

                                    {digital.map((item, index) => {
                                        const Icon = item.icon;

                                        return (
                                            <div
                                                key={index}
                                                className="d-flex align-items-start mb-3"
                                                data-aos="fade-left"
                                                data-aos-delay={index * 100}
                                            >
                                                <div className="me-3">
                                                    <Icon size={20} className="lanp-primary-text fw-bold"/>
                                                </div>
                                                <div>
                                                    <h6 className="fw-semibold mb-1">{item.title}</h6>
                                                    <small className="opacity-75">{item.desc}</small>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="col-md-6">
                                    <img src={pcworkimg} alt=" " className="w-100 rounded mb-4" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CompareSection;